import AgentFactory from '../../agents/agentFactory';

// Definir el slice como un objeto plano
const agentSlice = (set, get) => ({
  // Lista de agentes disponibles
  agents: AgentFactory.getAvailableAgents(),
  
  // Agente actualmente seleccionado
  selectedAgent: null,
  
  // Instancia del agente activo
  activeAgent: null,
  
  // Establecer el agente seleccionado
  setSelectedAgent: (agentKey) => {
    if (!agentKey) {
      set({ selectedAgent: null, activeAgent: null });
      return;
    }
    
    try {
      console.log('Creando instancia del agente:', agentKey);
      const agentInstance = AgentFactory.createAgent(agentKey);
      console.log('Instancia del agente creada:', agentInstance);
      
      // Actualizar el estado con el nuevo agente
      set({ 
        selectedAgent: agentKey,
        activeAgent: agentInstance
      });
      
      console.log('Agente seleccionado correctamente:', agentKey);

      // Al seleccionar un agente, solo crear un nuevo chat activo para ese agente
      const { createNewChat } = get();
      createNewChat(agentKey);

    } catch (error) {
      console.error('Error al crear el agente:', error);
      // Limpiar el estado en caso de error
      set({ selectedAgent: null, activeAgent: null });
      throw error;
    }
  },
  
  // Obtener la configuración de un agente
  getAgentConfig: (agentKey) => {
    try {
      return AgentFactory.getAgentConfig(agentKey);
    } catch (error) {
      console.error('Error al obtener la configuración del agente:', error);
      return null;
    }
  },
  
  // Obtener el agente activo
  getActiveAgent: () => {
    const state = get();
    return state.activeAgent;
  },
  
  // Verificar si un agente está activo
  isAgentActive: (agentKey) => {
    const state = get();
    return state.selectedAgent === agentKey;
  }
});

export default agentSlice;